exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav_tabs .right[data-v-58de782f]{color:#999999;line-height:40px}.child_page[data-v-58de782f]{padding:30px}\n", ""]);

// exports
